import Vue from 'vue'
import Vuex from 'vuex'

import defaultStates from '@/vuex/defaultStates'
import getters from '@/vuex/getters'
import mutations from '@/vuex/mutations'
import actions from '@/vuex/actions'
import modules from '@/vuex/modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: defaultStates,
  getters,
  mutations,
  actions,
  modules,
})

export default store
